export default __webpack_public_path__ + "static/media/search_close.47d1ed8b.svg";